import { ArrowRightAlt, Check, CheckCircle, DeliveryDining, Edit, Money, Sell, ShieldOutlined, Speed, Star, StarBorder, StarRate, SupportAgent, ThumbUp } from "@mui/icons-material";
import { Box, Button, Slider as RateSlider, Card, Checkbox, Grid, Input, DialogContent, DialogTitle, Link, Modal, ModalClose, ModalDialog, Stack, Typography, Divider, Chip, LinearProgress, FormControl, FormHelperText, Textarea, RadioGroup, Sheet, Radio } from "@mui/joy";
import { Transition } from 'react-transition-group';
import Quiz from "../Quiz";
import React, { useEffect, useState } from "react";
import contentData from '../content.json';
import { useNavigate } from "react-router-dom";
import OrderService from "../OrderService";
import Snowfall from 'react-snowfall'
import { Rating } from 'react-simple-star-rating'

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Slider from "react-slick";
import CarouselComp from "../Carousel";
import Tabs from '@mui/joy/Tabs';
import TabList from '@mui/joy/TabList';
import Tab from '@mui/joy/Tab';
import TabPanel from '@mui/joy/TabPanel';
import FeaturesTable from "../FeaturesTable";

const items = [
    { title: "Одобрим всем!", description: "Расрочка до 5 лет за 5 минут!", icon: contentData.isExtendedVersion ? "./images/icons/white-heavy-check-mark_2705.png" : "./images/icons/icons8-they-skin-type-2-48.png" },
    { title: "Простота!", description: "Без справок о доходах и лишних документах", icon: "./images/icons/icons8-_-_-48.png" },
    { title: "0%", description: "Расрочка без первого взноса", icon: "./images/icons/icons8-0-_-_-48.png" },
    { title: "Не выходя из дома!", description: "Бесплатная доставка в любую точку Беларуси за 1-3 дня", icon: "./images/icons/icons8-_-48.png" },
    { title: "Официальная гарантия", description: "2 года от производителя", icon: "./images/icons/icons8-_-48_89ea2c5f-0a4e-4724-9e66-6bf4c465ec6b.png" }
];

function Home() {
    const [open, setOpen] = useState(false);
    const [openReview, setOpenReview] = useState(false);

    const [reviewsShow, setReviewsShow] = useState(5);
    const [reviews, setReviews] = useState([
        {
            "name": "Иван",
            "message": "Купил мотоцикл. Доволен покупкой!",
            "stars": 5
        },
        {
            "name": "Алексей",
            "message": "Спасибо за мотоцикл! Искал именно эту модель по адекватной цене и случайно нашел ваш магазин в TikTok. Отдельная благодарность за быструю доставку.",
            "stars": 5
        },
        {
            "name": "Марина",
            "message": "Купила мотоцикл для мужа. Он в восторге! Сервис магазина на высшем уровне: помогли выбрать модель и оформили выгодные условия оплаты. Очень довольна!",
            "stars": 5
        },
        {
            "name": "Дмитрий",
            "message": "Искал новый мотоцикл. Друг посоветовал этот магазин. Заказ доставили за 4 дня. Однозначно рекомендую! Думаю, ещё возьму у вас что-нибудь.",
            "stars": 5
        },
        {
            "name": "Светлана",
            "message": "С мужем давно хотели приобрести мотоцикл, решили заказать в этом магазине. Оформили покупку в рассрочку, и ни разу не пожалели! Менеджер помог выбрать модель, быстро оформил заказ. Огромное спасибо!",
            "stars": 5
        },
        {
            "name": "Ольга",
            "message": "Купила мотоцикл для мужа. Менеджер помог с выбором, все подробно объяснил. Очень довольна покупкой!",
            "stars": 5
        },
        {
            "name": "Константин",
            "message": "Купил мотоцикл. Очень удобен и прост в использовании. Понравилось, что доставили на следующий день. Хороший сервис и качественный товар!",
            "stars": 5
        },
        {
            "name": "Елена",
            "message": "Купила мотоцикл для мужа. Очень благодарна за быстрое оформление и доставку!",
            "stars": 5
        },
        {
            "name": "Юрий",
            "message": "Купил мотоцикл. Весь процесс от выбора до доставки был на высшем уровне. Приятно удивила скорость доставки и качество товара. Спасибо за обслуживание!",
            "stars": 5
        },
        {
            "name": "Андрей",
            "message": "Очень доволен покупкой! Купил мотоцикл. Менеджер объяснил все, помог оформить рассрочку. Доставка была быстрой. Рекомендую магазин!",
            "stars": 5
        }
    ]);

    const [name, setName] = useState("");
    const [message, setMessage] = useState("");
    const [stars, setStars] = useState(5);
    const [selectedVariant, setSelectedVariant] = useState(
        contentData.variants ? contentData.variants[0] : null
    );

    const selectedImage =
        contentData.variantsImages && contentData.variantsImages.length > 0
            ? contentData.variantsImages[contentData.variants.indexOf(selectedVariant)]
            : './images/header.jpg';

    const [noMore, setNoMore] = useState(false);
    const loadMore = () => {
        if (reviewsShow == 100) {
            setNoMore(true);
        }
        else {
            setReviewsShow(100);
        }
    };

    const handleSubmitReview = () => {
        if (name.trim() && message.trim()) {
            const newReview = { name, stars, message };
            setReviews([newReview, ...reviews]);
            setName("");
            setMessage("");
            setStars(5);
            setOpenReview(false);
        }
    };

    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        politics: true
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleCheckChange = (e) => {
        const { checked } = e.target;
        setFormData({
            ...formData,
            politics: checked
        });
    };

    const handleSubmitData = async (e) => {
        e.preventDefault();

        if (!formData.politics) {
            alert("Сперва примите согласие с политикой конфиденциальности.");
            return;
        }

        if (formData.phone.length < 3 || formData.name.length < 3) {
            alert("Пожалуйста, введите корректные данные.");
            return;
        }

        await OrderService.createOrder(formData.phone, formData.name, "Заказан обратный звонок на консультацию");
        setFormData({
            name: '',
            phone: '',
            politics: true
        });
        window.location.href = '/thank_you';
    };

    const initialTime = 16 * 60 + 45;
    const [timeLeft, setTimeLeft] = useState(initialTime);

    useEffect(() => {
        if (timeLeft === 0) return;

        const timer = setInterval(() => {
            setTimeLeft(prevTime => prevTime - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [timeLeft]);

    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '0',
        arrows: false,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                },
            },
        ],
    };

    useEffect(() => {
        document.title = contentData.title;
    });

    return (
        <>
            {/* 
            <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }}>
                <Snowfall speed={[0.1, 0.5]} />
            </div>
*/}
            <Box sx={{ textAlign: 'center' }}>
                <Box sx={{ backgroundColor: 'white', p: 2 }}>
                    {contentData.isExtendedVersion ? (
                        <>
                            <Typography level="h4" sx={{ color: 'black', fontWeight: 300 }}><span style={{ fontWeight: 700 }}>Одобряем рассрочку всем.<br />{contentData.titleEdit} от {contentData.minPrice} руб/мес.</span></Typography>
                            <Typography level="title-md" sx={{ color: 'red', display: contentData.gift ? 'block' : 'none' }}>2 подарка к каждому заказу!</Typography>
                        </>
                    ) : (
                        <Typography level="h4" sx={{ color: 'black', fontWeight: 400 }}>Более 300 моделей {contentData.headerTitle} {isMobile ? <br /> : ""} от <span style={{ fontWeight: 760 }}>{contentData.minPrice} руб/мес</span> <span style={{ textDecoration: 'line-through' }}>{contentData.minPrice * 2} руб/мес</span></Typography>
                        //<Typography level="h4" sx={{ color: 'black', fontWeight: 400 }}>Распродажа склада бытовой техники <br /> от <span style={{ fontWeight: 760 }}>{contentData.minPrice} руб/мес</span> <span style={{ textDecoration: 'line-through' }}>{contentData.minPrice * 2} руб/мес</span></Typography>
                    )}
                </Box>
                <Box sx={{
                    backgroundColor: !contentData.newYear ? 'red' : '#0B6BCB',
                    py: 2,
                    color: 'white',
                    fontWeight: 'bold',
                    fontSize: 16,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    maxWidth: '100%',
                }}>
                    <div class="ticker__in">
                        <span class="ticker__item">Самое выгодное предложение - 50% Скидка 🔥!</span>
                        <span class="ticker__item">Самое выгодное предложение - 50% Скидка 🔥!</span>
                        <span class="ticker__item">Самое выгодное предложение - 50% Скидка 🔥!</span>
                        <span class="ticker__item">Самое выгодное предложение - 50% Скидка 🔥!</span>
                        <span class="ticker__item">Самое выгодное предложение - 50% Скидка 🔥!</span>
                        <span class="ticker__item">Самое выгодное предложение - 50% Скидка 🔥!</span>
                        <span class="ticker__item">Самое выгодное предложение - 50% Скидка 🔥!</span>
                        <span class="ticker__item">Самое выгодное предложение - 50% Скидка 🔥!</span>
                        <span class="ticker__item">Самое выгодное предложение - 50% Скидка 🔥!</span>
                        <span class="ticker__item">Самое выгодное предложение - 50% Скидка 🔥!</span>
                        <span class="ticker__item">Самое выгодное предложение - 50% Скидка 🔥!</span>
                        <span class="ticker__item">Самое выгодное предложение - 50% Скидка 🔥!</span>
                    </div>
                    {/* 
                    {contentData.newYear && (
                        <div class="gir_1" id="gir"></div>
                    )}
*/}
                </Box>
                <Box sx={{ maxWidth: '1200px', justifyContent: 'center', display: 'flex', margin: '0 auto' }}>
                    <Box sx={{ mt: 4, width: '100%' }}>
                        <Card variant="solid" sx={{ mt: 2, mb: 2, borderRadius: 20, mx: 2, backgroundColor: 'white' }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: { xs: "column", md: "row" },
                                    width: "100%",
                                    borderRadius: 20,
                                }}
                            >
                                <Box
                                    sx={{
                                        flex: 1,
                                        borderRadius: 20
                                    }}
                                >
                                    {contentData.needCarousel && !(contentData.variants && contentData.variants.length > 0) ? (
                                        <CarouselComp images={contentData.variantsImages} />
                                    ) : (
                                        <img style={{ height: 'auto', borderRadius: 14, width: '100%', objectFit: 'cover' }} src={selectedImage} alt={selectedVariant} />
                                    )}
                                </Box>
                                <Box
                                    sx={{
                                        flex: 1,
                                        borderRadius: 20
                                    }}
                                >
                                    <Box sx={{ width: '100%', textAlign: 'left', ml: isMobile ? 0 : 2, mt: isMobile ? 1 : 0 }}>
                                        <Chip sx={{ ml: -0.4, mb: 0.5 }} color="primary" variant="soft">Рассрочка под 0% 💝</Chip>
                                        <Stack spacing={0.5}>
                                            <Typography level="h3">{contentData.title}</Typography>
                                            <Typography>От <span style={{ fontWeight: 760 }}>{contentData.minPrice} руб/мес</span> <span style={{ textDecoration: 'line-through' }}>{contentData.minPrice * 2} руб/мес</span> (-50%🔥)</Typography>
                                            <Rating size={20} readonly initialValue={5} />
                                            <Divider />
                                            <Typography color="success">
                                                <CheckCircle style={{ fontSize: '18px', verticalAlign: 'middle', marginTop: '-4px' }} /> В наличии
                                            </Typography>
                                            <Typography>Цвет: <Typography sx={{ fontWeight: 500 }}>любой по запросу</Typography></Typography>
                                            {contentData.variants && contentData.variants.length > 0 && (
                                                <RadioGroup
                                                    aria-labelledby="label"
                                                    defaultValue={contentData.variants[0]}
                                                    size="sm"
                                                    sx={{ gap: 1.5, flexDirection: 'row' }}
                                                    onChange={(event) => setSelectedVariant(event.target.value)}
                                                >
                                                    {contentData.variants.map((value) => (
                                                        <Sheet key={value} sx={{ p: 1, borderRadius: 'md', boxShadow: 'sm' }}>
                                                            <Radio
                                                                label={`${value}`}
                                                                overlay
                                                                disableIcon
                                                                value={value}
                                                                slotProps={{
                                                                    label: ({ checked }) => ({
                                                                        sx: {
                                                                            fontWeight: 'lg',
                                                                            fontSize: 'md',
                                                                            color: checked
                                                                                ? !contentData.newYear
                                                                                    ? '#C41C1C'
                                                                                    : '#1C1CC4'
                                                                                : 'text.secondary'
                                                                        },
                                                                    }),
                                                                    action: ({ checked }) => ({
                                                                        sx: (theme) => ({
                                                                            ...(checked && {
                                                                                '--variant-borderWidth': '2px',
                                                                                '&&': {
                                                                                    borderColor: !contentData.newYear ? theme.vars.palette.danger[500] : theme.vars.palette.primary[500],
                                                                                },
                                                                            }),
                                                                        }),
                                                                    }),
                                                                }}
                                                            />
                                                        </Sheet>
                                                    ))}
                                                </RadioGroup>
                                            )}
                                        </Stack>
                                        <Divider sx={{ mt: 2 }} />
                                        <Box sx={{ width: '100%', textAlign: 'center', mt: 2 }}>
                                            <Typography>Спешите! Акция заканчивается через</Typography>
                                            <Typography level="h2" sx={{ color: !contentData.newYear ? 'red' : '#0B6BCB', mt: 2 }}><span style={{ padding: "6px 10px", backgroundColor: !contentData.newYear ? 'red' : '#0B6BCB', color: 'white' }}>{String(minutes).padStart(2, '0')}</span> : <span style={{ padding: "6px 10px", backgroundColor: !contentData.newYear ? 'red' : '#0B6BCB', color: 'white' }}>{String(seconds).padStart(2, '0')}</span></Typography>
                                        </Box>
                                        <Box sx={{ width: '100%', mt: 4, padding: '0 20px', boxSizing: 'border-box' }}>
                                            <Button
                                                color={!contentData.newYear ? "danger" : "primary"}
                                                variant="solid"
                                                size="lg"
                                                onClick={() => setOpen(true)}
                                                sx={{ borderRadius: 250, width: '100%' }}
                                                endDecorator={<ArrowRightAlt />}
                                            >
                                                Узнать цену
                                            </Button>
                                        </Box>

                                        <Box
                                            sx={{
                                                display: "flex",
                                                width: "100%",
                                                padding: '0 20px', boxSizing: 'border-box',
                                                mt: 2
                                            }}
                                        >
                                            <Card
                                                variant="soft"
                                                color="warning"
                                                sx={{
                                                    flex: 1,
                                                    borderRadius: 20,
                                                    mr: 0.5
                                                }}
                                            >
                                                <Stack spacing={0.4}>
                                                    <Typography level="body-xs">
                                                        <DeliveryDining style={{ fontSize: '18px', verticalAlign: 'middle', marginTop: '-4px' }} /> Курьером до двери
                                                    </Typography>
                                                    <Typography level="body-sm">
                                                        Бесплатно доставим в любую точку Беларуси за 1-3 дня.
                                                    </Typography>
                                                </Stack>
                                            </Card>
                                            <Card
                                                variant="soft"
                                                color="warning"
                                                sx={{
                                                    flex: 1,
                                                    borderRadius: 20,
                                                    ml: 0.5
                                                }}
                                            >
                                                <Stack spacing={0.4}>
                                                    <Typography level="body-xs">
                                                        <Speed style={{ fontSize: '18px', verticalAlign: 'middle', marginTop: '-4px' }} /> Быстрая рассрочка
                                                    </Typography>
                                                    <Typography level="body-sm">
                                                        Одобрим рассрочку за 5 минут.
                                                    </Typography>
                                                </Stack>
                                            </Card>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Card>
                        <Box sx={{ mb: 2 }}>
                            {useMediaQuery(theme.breakpoints.down("lg")) ? (
                                <Slider {...settings}>
                                    {items.map((item, index) => (
                                        <div key={index}>
                                            <Box sx={{ width: '100%' }}>
                                                <Box>
                                                    <Card
                                                        variant="plain"
                                                        sx={{
                                                            borderRadius: 250,
                                                            mb: 0.4,
                                                            width: '50px',
                                                            height: '50px',
                                                            margin: '0 auto',
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                        }}
                                                    >
                                                        <img style={{ aspectRatio: '1/1', height: "36px" }} src={item.icon} />
                                                    </Card>
                                                    <Typography level="title-md">{item.title}</Typography>
                                                    <Typography>{item.description}</Typography>
                                                </Box>
                                            </Box>
                                        </div>
                                    ))}
                                </Slider>

                            ) : (
                                <Box sx={{
                                    display: 'flex',
                                    flexWrap: 'nowrap',
                                    justifyContent: 'flex-start',
                                    overflowX: 'auto',
                                    gap: 2
                                }}>
                                    {items.map((item, index) => (
                                        <Box key={index} sx={{
                                            width: 280,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            padding: '16px',
                                            borderRadius: '8px'
                                        }}>
                                            <Card variant="plain" sx={{ borderRadius: 250, mb: 0.4 }}>
                                                <img style={{ aspectRatio: '1/1', height: "36px" }} src={item.icon} />
                                            </Card>
                                            <Typography level="title-md">{item.title}</Typography>
                                            <Typography>{item.description}</Typography>
                                        </Box>
                                    ))}
                                </Box>
                            )}
                        </Box>
                        
                        <Box sx={{ mt: 4, mb: 2 }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: { xs: "column", md: "row" },
                                    width: "calc(100% - 30px)",
                                    borderRadius: 20,
                                    textAlign: 'left',
                                    ml: isMobile ? 2 : 0
                                }}
                            >
                                <Box
                                    sx={{
                                        flex: 1
                                    }}
                                >
                                    <Typography level="body-sm">Напишите нам</Typography>
                                    <Typography level="h2">Есть вопросы?</Typography>
                                </Box>
                                <Box
                                    sx={{
                                        flex: 1
                                    }}
                                >
                                    <Card variant="plain" sx={{ borderRadius: 20, p: 6, mt: isMobile ? 2 : 0 }}>
                                        <Typography level="title-md">Оставьте свои данные и мы вас проконсультируем</Typography>
                                        <form onSubmit={handleSubmitData}>
                                            <Stack spacing={1}>
                                                <Input
                                                    placeholder="Имя..."
                                                    name="name"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    style={{ borderRadius: '250px', padding: 8 }}
                                                />
                                                <Input
                                                    placeholder="Номер телефона..."
                                                    name="phone"
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                    style={{ borderRadius: '250px', padding: 8 }}
                                                />
                                                {contentData.needsPolicy && (
                                                    <FormControl size="sm" sx={{ marginTop: '14px' }}>
                                                        <Checkbox
                                                            color={!contentData.newYear ? "danger" : "primary"}
                                                            name='politics'
                                                            checked={formData.politics}
                                                            onChange={handleCheckChange}
                                                            label={
                                                                <React.Fragment>
                                                                    Я прочитал и согласен с{' '}
                                                                    <Typography sx={{ fontWeight: 'md' }}>политикой конфиденциальности</Typography>.
                                                                </React.Fragment>
                                                            }
                                                        />
                                                        <FormHelperText>
                                                            <Typography level="body-sm">
                                                                Прочитайте нашу <Link href="https://citrustele.by/documents/politics.html">политику конфиденциальности</Link>.
                                                            </Typography>
                                                        </FormHelperText>
                                                    </FormControl>
                                                )}
                                                <Box sx={{ width: "100%", display: 'flex', justifyContent: contentData.isExtendedVersion ? 'center' : '' }}>
                                                    <Button type="submit" color={!contentData.newYear ? "danger" : "primary"} sx={{ borderRadius: 250, mt: contentData.isExtendedVersion ? 1 : 0 }} size="md">
                                                        Получить консультацию
                                                    </Button>
                                                </Box>
                                            </Stack>
                                        </form>
                                    </Card>
                                </Box>
                            </Box>
                        </Box>
                        <Stack sx={{ textAlign: 'center', p: 2, pb: 12, borderRadius: !contentData.needForm ? 0 : '20px 20px 0px 0px' }}>
                            <Divider sx={{ mb: 2 }} />
                            <Typography sx={{ mb: 2 }}>Время работы: пн-вс 09:00 - 21:00</Typography>
                            {contentData.talisman ? (<>
                                <Typography>ООО "КЦ Талисман" УНП 193791314</Typography>
                                <Typography sx={{ mb: 2 }}>220055, г. Минск, ул. Каменногорская 47, пом. 95, каб 2-30</Typography>
                                <Typography level="title-md">Акция действует на всей территории Беларуси</Typography>
                                <Typography sx={{ display: 'none' }}>Телефон: +375 (44) 544-78-15</Typography>
                                <Typography>E-mail: kctalisman@gmail.com</Typography>
                            </>
                            ) : (<>
                                <Typography>ООО "Цитруском" УНП 193699866</Typography>
                                <Typography sx={{ mb: 2 }}>220046, г. Минск, а/я 46</Typography>
                                <Typography level="title-md">Акция действует на всей территории Беларуси</Typography>
                                <Typography>Телефон: +375 (29) 314-23-63</Typography>
                                <Typography>E-mail: citrustele@mail.ru</Typography>
                            </>)}
                            {contentData.needsPolicy && (
                                <Stack sx={{ width: '100%', alignItems: 'center', display: 'flex' }} >
                                    <Link href="https://citrustele.by/documents/politics.html">Политика конфиденциальности</Link>
                                    <Link href="https://citrustele.by/documents/agreement.html">Пользовательское соглашение</Link>
                                    <Link href="https://citrustele.by/documents/dogovor_vozvrata.html">Договор возврата</Link>
                                    <Link href="https://citrustele.by/documents/dostavka.html">Договор доставки</Link>
                                </Stack>
                            )}
                        </Stack>
                    </Box>
                </Box>
            </Box >
            <Transition in={open} timeout={400}>
                {(state) => (
                    <Modal
                        keepMounted
                        open={!['exited', 'exiting'].includes(state)}
                        onClose={() => setOpen(false)}
                        slotProps={{
                            backdrop: {
                                sx: {
                                    opacity: 0,
                                    backdropFilter: 'none',
                                    transition: `opacity 400ms, backdrop-filter 400ms`,
                                    ...{
                                        entering: { opacity: 1, backdropFilter: 'blur(8px)' },
                                        entered: { opacity: 1, backdropFilter: 'blur(8px)' },
                                    }[state],
                                },
                            },
                        }}
                        sx={{
                            visibility: state === 'exited' ? 'hidden' : 'visible',
                        }}
                    >
                        <ModalDialog
                            variant="soft"
                            sx={{
                                opacity: 0,
                                borderRadius: 20,
                                backgroundColor: 'white',
                                transition: `opacity 300ms`,
                                ...{
                                    entering: { opacity: 1 },
                                    entered: { opacity: 1 },
                                }[state],
                            }}
                        >
                            <ModalClose sx={{ backgroundColor: 'white', zIndex: 0 }} />
                            <DialogContent sx={{ height: '100%', mt: 1 }}>
                                <Quiz variant={selectedVariant} questions={contentData.questions} />
                            </DialogContent>
                        </ModalDialog>
                    </Modal>
                )}
            </Transition>

            <Transition in={openReview} timeout={400}>
                {(state) => (
                    <Modal
                        keepMounted
                        open={!['exited', 'exiting'].includes(state)}
                        onClose={() => setOpenReview(false)}
                        slotProps={{
                            backdrop: {
                                sx: {
                                    opacity: 0,
                                    backdropFilter: 'none',
                                    transition: `opacity 400ms, backdrop-filter 400ms`,
                                    ...{
                                        entering: { opacity: 1, backdropFilter: 'blur(8px)' },
                                        entered: { opacity: 1, backdropFilter: 'blur(8px)' },
                                    }[state],
                                },
                            },
                        }}
                        sx={[
                            state === 'exited'
                                ? { visibility: 'hidden' }
                                : { visibility: 'visible' },
                        ]}
                    >
                        <ModalDialog
                            variant="soft"
                            sx={{
                                opacity: 0,
                                borderRadius: 20,
                                backgroundColor: 'white',
                                transition: `opacity 300ms`,
                                ...{
                                    entering: { opacity: 1 },
                                    entered: { opacity: 1 },
                                }[state],
                            }}
                        >
                            <ModalClose sx={{ backgroundColor: 'white', zIndex: 0 }} />
                            <DialogTitle>Оставьте отзыв!</DialogTitle>
                            <DialogContent sx={{ overflow: 'hidden', p: 0 }}>
                                <Stack sx={{ width: '100%', height: 'fit-content' }} spacing={1}>
                                    <Input
                                        sx={{ borderRadius: 20 }}
                                        placeholder="Ваше имя..."
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                    <Textarea
                                        sx={{ borderRadius: 20 }}
                                        placeholder="Ваш отзыв..."
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                    />
                                    <Stack spacing={0}>
                                        <Typography>Ваша оценка:</Typography>
                                        <Box sx={{ mx: 0.1 }}>
                                            <RateSlider
                                                color={!contentData.newYear ? "danger" : "primary"}
                                                marks
                                                orientation="horizontal"
                                                size="sm"
                                                valueLabelDisplay="on"
                                                variant="soft"
                                                value={stars}
                                                onChange={(e, value) => setStars(value)}
                                                max={5}
                                            />
                                        </Box>
                                    </Stack>
                                    <Button onClick={handleSubmitReview} color={!contentData.newYear ? "danger" : "primary"} sx={{ borderRadius: 250 }}>Отправить!</Button>
                                </Stack>
                            </DialogContent>
                        </ModalDialog>
                    </Modal>
                )}
            </Transition>
        </>
    );
}

export default Home;
